import Vue from 'vue'
import { GChart } from "vue-google-charts/legacy"

Vue.component('GChart', GChart)
